type SpecsFilterBarProps = {
    options: string[];
    currentFilter: string;
    onChange: (value: string) => void;
};

export default function SpecsFilterBar({
    options,
    currentFilter,
    onChange,
}: SpecsFilterBarProps) {
    return (
        <div
            className="
        flex items-center 
        gap-2 sm:gap-3 
        overflow-x-auto 
        scrollbar-hide 
        py-2 px-1 
        w-full
      "
        >
            {options.map((opt) => (
                <button
                    key={opt}
                    onClick={() => onChange(opt)}
                    className={`
            flex-shrink-0 
            px-4 sm:px-5 py-2 sm:py-2.5 
            rounded-lg font-medium 
            border transition-colors duration-150 
            text-sm sm:text-base 
            whitespace-nowrap 
            ${currentFilter === opt
                            ? "bg-[#F97316] text-white border-[#F97316]"
                            : "bg-white text-gray-700 border-gray-200 hover:bg-gray-100"
                        }
          `}
                >
                    {opt}
                </button>
            ))}
        </div>
    );
}
